import Vue from 'vue';
import Router from 'vue-router';
import store from '../store'

import ProjectListPage from '../pages/project/project-list.vue';
import LookupListPage from '../pages/lookup/lookup-list.vue';
import ProjectDetailPage from '../pages/project/project-detail.vue';
import ProjectCreatePage from '../pages/project/project-create.vue';
import ProjectSimpleDetailPage from '../pages/projectSimple/project-detail.vue';
import ProjectSimpleCreatePage from '../pages/projectSimple/project-create.vue';
import ProjectSimpleListPage from '../pages/projectSimple/project-list.vue';
import LoginPage from '../pages/login/login-page.vue';
import PasswordResetPage from '../pages/login/password-reset-page.vue';
import PasswordNewPage from '../pages/login/password-new-page.vue';
import UserListPage from '../pages/user/user-list.vue';
import UserDetailPage from '../pages/user/user-detail.vue';
import TemplateListPage from '../pages/template/template-list.vue';
import NotFoundPage from '../pages/error/404.vue';
import NotAuthorizedPage from '../pages/error/401.vue';

Vue.use(Router);

function checkAdminRights(to: any, from: any, next: any) {
  const user = JSON.parse(localStorage.getItem('user') || 'null');

  if (user?.user.role === 'Administrator') {
    next();
  } else {
    next('/401');
  }
}

export const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', component: ProjectListPage },
    { path: '/ciselniky', component: LookupListPage, beforeEnter: checkAdminRights },
    { path: '/prihlaseni', component: LoginPage },
    { path: '/reset-hesla', component: PasswordResetPage },
    { path: '/nove-heslo/:token/:userKey', component: PasswordNewPage },
    {
      path: '/projekt/:id',
      component: ProjectDetailPage
    },
    { path: '/zalozeni-projektu', component: ProjectCreatePage },
    { path: '/program/:id', component: ProjectSimpleDetailPage },
    { path: '/zalozeni-programu', component: ProjectSimpleCreatePage },
    { path: '/programy', component: ProjectSimpleListPage },
    { path: '/seznam-uzivatelu', component: UserListPage, beforeEnter: checkAdminRights },
    { path: '/emailove-sablony', component: TemplateListPage, beforeEnter: checkAdminRights },
    { path: '/detail-uzivatele', component: UserDetailPage },
    { path: '/404', component: NotFoundPage },
    { path: '/401', component: NotAuthorizedPage },

    // otherwise redirect to home
    { path: '*', redirect: '/404' }
  ]
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/prihlaseni', '/reset-hesla'];
  const publicPagesWithParameters = ['/nove-heslo'];
  const authRequired = !publicPages.includes(to.path) && !publicPagesWithParameters.find(url => to.path.startsWith(url));
  
  if (authRequired) {
    store.dispatch('account/getUser').then(user=>{
      if(user && user.user && user.user.isDisabled){
        return next('/401');
      }
    }).catch(err=> { return next('/prihlaseni');});
  }

  next();
});

export default router;
